import { render, staticRenderFns } from "./GBuyerUserInfoForm.vue?vue&type=template&id=2460013e&scoped=true&"
import script from "./GBuyerUserInfoForm.vue?vue&type=script&lang=ts&"
export * from "./GBuyerUserInfoForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBuyerUserInfoForm.vue?vue&type=style&index=0&id=2460013e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2460013e",
  null
  
)

export default component.exports